import React from "react";
import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import colors from "../../theme";

const EnergyConsumptionCard = ({ type, value }) => (
  <Box sx={{ backgroundColor: colors.mainContentBgColor }}>
    <Card
      sx={{
        backgroundColor: colors.mainContentBgColor,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        margin: 2,
      }}
    >
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
          my: 0,
          padding: "5px !important",
        }}
      >
        <Grid container>
          <Grid
            item
            xs={12}
            my={0.5}
            sx={{
              textAlign: "center",
              color: colors.primary,
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              {type}
            </Typography>
          </Grid>

          <Grid
            item
            xs={12}
            my={0.5}
            sx={{
              textAlign: "center",
            }}
          >
            <Typography variant="h5" sx={{ fontWeight: "bold" }}>
              {value}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  </Box>
);
export default EnergyConsumptionCard;
